module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10235.532a10a6.jpg";